import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=848d6cce"
import script from "./radio-group.vue?vue&type=script&lang=js"
export * from "./radio-group.vue?vue&type=script&lang=js"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=848d6cce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports